import { render, staticRenderFns } from "./SummaryPage.vue?vue&type=template&id=05d6d0d8&scoped=true"
import script from "./SummaryPage.vue?vue&type=script&lang=js"
export * from "./SummaryPage.vue?vue&type=script&lang=js"
import style0 from "./SummaryPage.vue?vue&type=style&index=0&id=05d6d0d8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d6d0d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d6d0d8')) {
      api.createRecord('05d6d0d8', component.options)
    } else {
      api.reload('05d6d0d8', component.options)
    }
    module.hot.accept("./SummaryPage.vue?vue&type=template&id=05d6d0d8&scoped=true", function () {
      api.rerender('05d6d0d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/use-metrics/pages/SummaryPage.vue"
export default component.exports